/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
/**
 * Keeps track of seed and handles pseudorandomness
 * Instance created in BaseRandomLayer class
 * Utilized for random preprocessing layers
 */
let RandomSeed = /*#__PURE__*/(() => {
  class RandomSeed {
    constructor(seed) {
      this.seed = seed;
    }
    next() {
      if (this.seed === undefined) {
        return undefined;
      }
      return this.seed++;
    }
  }
  RandomSeed.className = 'RandomSeed';
  return RandomSeed;
})();
export { RandomSeed };
